import { render, staticRenderFns } from "./shopPurchaseEdit.vue?vue&type=template&id=308e95bd&scoped=true&"
import script from "./shopPurchaseEdit.vue?vue&type=script&lang=js&"
export * from "./shopPurchaseEdit.vue?vue&type=script&lang=js&"
import style0 from "./shopPurchaseEdit.vue?vue&type=style&index=0&id=308e95bd&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308e95bd",
  null
  
)

export default component.exports